import { useEffect, useState} from 'react';
import { CircularProgress, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import styles from './listPublicationStates.module.scss';
import { addPointsInText } from '../../../../helpers/app';
import { ListPublicationStatesDashboardProps } from '../../../../interfaces/components';
import { images } from '../../../../constants/images';
import { useToast } from '../../../../helpers/hooks';
import moment from 'moment';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';

const ListPublicationStates = ({
    user,
    getStatusChangesPublications,
    cleanStatusChangesPublications,
    getStatusChangesTransactions,
    cleanStatusChangesTransactions,
    statusChanges,
    branch,
    date,
    className = undefined
}: ListPublicationStatesDashboardProps) => {
    const toast = useToast();
    const navigate = useNavigate();
    const [section, setSection] = useState<string>("publication");

    const onNavigate = (id: any) => {
        if(id) navigate(`/profile/my_publications/${id}/management`);
    }

    const noDataChart = () => (
        <TableRow className={styles.row}>
            <TableCell colSpan={5}>
                <div className={styles.noData}>
                    <img src={images.noBuys} alt="NoData" />
                    <p>Aún no hay datos disponibles en esta sección</p>
                </div>
            </TableCell>
        </TableRow>
    );

    const rowChart = (chart: any, index: number) => {
        let stateCode = "";
        switch(chart?.status.toLowerCase()){
            case "finalizado":
            case "entregado":
                stateCode = styles.green
                break;
            case "cancelado":
                stateCode = styles.red
                break;
            case "inspeccion":
                stateCode = styles.gray
                break;
            default:
                stateCode = styles.blue
                break;
        }
        return (
            <TableRow className={styles.row} key={index} onClick={() => onNavigate(chart?.publication)}>
                {
                    user?.profile?.code !== "seller" &&
                    <TableCell className={`${styles.cell} ${styles.ellipsis}`}>
                        <p className={`${styles.bold} ${styles.text}`}>{chart?.user ?? chart?.seller}</p>
                    </TableCell>
                }
                <TableCell className={styles.cell}>
                    <p className={styles.text}>{moment(chart?.date).format('DD MMM YYYY')}</p>
                </TableCell>
                <TableCell className={`${styles.cell} ${styles.ellipsis}`}>
                    <p className={styles.text}>{chart?.vehicle}</p>
                </TableCell>
                <TableCell className={styles.cell}>
                    <div className={`${styles.text} ${styles.state} ${stateCode}`}>{chart?.status.toUpperCase()}</div>
                </TableCell>
                <TableCell className={styles.cell}>
                    <p className={styles.text}>${addPointsInText(chart?.price)}</p>
                </TableCell>
            </TableRow>
        );
    }

    useEffect(() => {
        if(statusChanges?.publications?.fetching === "failure"){
            if(statusChanges?.publications?.error){
                toast("Ha ocurrido un error al mostrar los cambios de estados de las publicaciones");
            }
            cleanStatusChangesPublications();
        }
        if(statusChanges?.publications?.fetching === "success"){
            cleanStatusChangesPublications();
        }
    }, [statusChanges?.publications?.fetching]);

    useEffect(() => {
        if(statusChanges?.transactions?.fetching === "failure"){
            if(statusChanges?.transactions?.error){
                toast("Ha ocurrido un error al mostrar los cambios de estados de las transacciones");
            }
            cleanStatusChangesTransactions();
        }
        if(statusChanges?.transactions?.fetching === "success"){
            cleanStatusChangesTransactions();
        }
    }, [statusChanges?.transactions?.fetching]);

    useEffect(() => {
        if(!!date?.start.length && !!date?.end.length && (user?.branch || branch !== "")){
            getStatusChangesPublications(date?.start, date?.end);
            getStatusChangesTransactions(date?.start, date?.end);
        }
    }, [date, branch]);

    return(
        <div className={`${styles.listPublicationStates} ${className}`}>
            <div className={styles.header}>
                <p className={styles.title}>
                    <span className={styles.label}>{`Cambios de estados de ${section === "publication" ? "publicaciones" : "transacciones"}`}</span>
                </p>
                <div className={styles.arrows}>
                    <IconButton id="arrowLeft" className={`${styles.arrow} ${styles.left}`} disabled={section === "publication"} onClick={() => setSection("publication")}>
                        <ArrowBackIosNewIcon className={styles.icon} />
                    </IconButton>
                    <IconButton id="arrowRight" className={`${styles.arrow} ${styles.right}`} disabled={section === "transaction"} onClick={() => setSection("transaction")}>
                        <ArrowBackIosNewIcon className={styles.icon} />
                    </IconButton>
                </div>
            </div>
            <TableContainer className={styles.table}>
                <Table>
                    <TableHead>
                        <TableRow className={styles.head}>
                            {
                                user?.profile?.code !== "seller" &&
                                <TableCell className={styles.cell}>Vendedor</TableCell>
                            }
                            <TableCell className={styles.cell}>Fecha</TableCell>
                            <TableCell className={styles.cell}>Vehiculo</TableCell>
                            <TableCell className={styles.cell}>Estado</TableCell>
                            <TableCell className={styles.cell}>Precio</TableCell>
                        </TableRow>
                        </TableHead>
                    <TableBody>
                    {
                        statusChanges?.publications?.fetching === "loading" || statusChanges?.transactions?.fetching === "loading"
                        ?
                            <TableRow className={styles.row}>
                                <TableCell colSpan={5}>
                                    <div className={styles.loading}>
                                        <CircularProgress 
                                            size={styles.loader}
                                            classes={{
                                                colorPrimary: styles.loader
                                            }}
                                        />
                                        <p className={styles.text}>Buscando {section === "publication" ? "publicaciones" : "transacciones"}</p>
                                    </div>
                                </TableCell>
                            </TableRow>
                        :
                            section === "publication"
                            ?
                                statusChanges?.publications?.data && statusChanges?.publications?.data.length === 0
                                ?   
                                    noDataChart()
                                :
                                    statusChanges?.publications?.data?.map((item: any, index: number) => (
                                        rowChart(item, index)
                                    ))
                            :
                                statusChanges?.transactions?.data && statusChanges?.transactions?.data.length === 0
                                ?   
                                    noDataChart()
                                :
                                    statusChanges?.transactions?.data?.map((item: any, index: number) => (
                                        rowChart(item, index)
                                    ))
                    }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default ListPublicationStates;